import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Units from "@/pages/Units";
import Tenants from "@/pages/Tenants";
import Contracts from "@/pages/Contracts";
import Bills from "@/pages/Bills";
import BillDetail from "@/pages/BillDetail";
import Receipt from "@/pages/Receipt";
import Handovers from "@/pages/Handovers";
import Expenses from "@/pages/Expenses";
import Reports from "@/pages/Reports";
import UsersPage from "@/pages/Users";
import AuditLogs from "@/pages/AuditLogs";
import TenantPortal from "@/pages/TenantPortal";
import TenantPortalReceipt from "@/pages/TenantPortalReceipt";
import Properties from "@/pages/Properties";
import TransferProofs from "@/pages/TransferProofs";
import ContractPrint from "@/pages/ContractPrint";
import WaLogs from "@/pages/WaLogs";
import WaTemplates from "@/pages/WaTemplates";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/portal/:token" element={<TenantPortal />} />
            <Route path="/portal/:token/receipt/:paymentId" element={<TenantPortalReceipt />} />
            <Route path="/" element={<Shell><Dashboard /></Shell>} />
            <Route path="/units" element={<Shell><Units /></Shell>} />
            <Route path="/tenants" element={<Shell><Tenants /></Shell>} />
            <Route path="/contracts" element={<Shell><Contracts /></Shell>} />
            <Route path="/bills" element={<Shell><Bills /></Shell>} />
            <Route path="/bills/:id" element={<Shell><BillDetail /></Shell>} />
            <Route path="/receipt/:id" element={<Shell><Receipt /></Shell>} />
            <Route path="/handovers" element={<Shell><Handovers /></Shell>} />
            <Route path="/expenses" element={<Shell><Expenses /></Shell>} />
            <Route path="/reports" element={<Shell><Reports /></Shell>} />
            <Route path="/users" element={<Shell><UsersPage /></Shell>} />
            <Route path="/audit-logs" element={<Shell><AuditLogs /></Shell>} />
            <Route path="/properties" element={<Shell><Properties /></Shell>} />
            <Route path="/transfer-proofs" element={<Shell><TransferProofs /></Shell>} />
            <Route path="/contracts/:id/print" element={<Shell><ContractPrint /></Shell>} />
            <Route path="/wa-logs" element={<Shell><WaLogs /></Shell>} />
            <Route path="/wa-templates" element={<Shell><WaTemplates /></Shell>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </AuthProvider>
    </div>
  );
}
